// @flow
import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { Box, Heading } from '@medeo/components'
import { getAllPatients, selectPatient } from '@medeo/patients'
import * as fromGoals from '../../Goal/actions'
const defaultProps = {
  patients: []
}

const ListItem = Box.withComponent('li').extend`
      list-style: none;
      margin: 1rem 0;
      display: flex;
      justify-content: space-between;
      & > div {
       display: flex; 
       flex-direction: column;
      }

`
const List = styled.ul`
  margin: 2rem auto 0;
  padding: 0;
  width: 50rem;
`
const renderPatientName = patient => {
  const [name] = patient.name
  const { family, given: [given] } = name
  return (
    <span key="family">
      {family} {given}
    </span>
  )
}

const renderPatientAge = patient => {
  return <span key="age">{moment(patient.birthDate).calendar()}</span>
}

const PatientsList = ({ patients, loadGoals } = defaultProps) => (
  <div>
    {patients.length < 1 ? (
      <FormattedMessage id="emptyPatientList"/>
    ) : (
      <List key="list">
        <Heading key="title" size={24}>
          patients
        </Heading>
        {patients.map(patient => (
          <ListItem key={patient.id}>
            <div>
              {renderPatientName(patient)}
              {renderPatientAge(patient)}
            </div>

            <Link to={`/patients/${patient.id}`}>ouvrir</Link>
          </ListItem>
        ))}
      </List>
    )}
  </div>
)

const mapStateToProps = state => ({
  patients: getAllPatients(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      selectPatient: selectPatient,
      loadGoals: fromGoals.loadGoals
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(PatientsList)

/*<br />
            <Link
              to={`/goals/edit/${patient.id}`}
              onClick={() => {
                loadGoals(patient.id)
              }}
            >
              Modifier
            </Link>*/



// WEBPACK FOOTER //
// ./src/Patients/containers/PatientsList.js